import React, { useCallback } from 'react';
import { LOCK_STATE } from '~/web-frontend-core/api/const/base';
export var LIGHT;
(function (LIGHT) {
    LIGHT["GREEN"] = "b-green";
    LIGHT["RED"] = "b-orange";
    LIGHT["NONE"] = "";
})(LIGHT || (LIGHT = {}));
export const highlightCoefChanges = (CoefTD) => {
    const highlightedCoefChanges = (props) => {
        const { coef, disabled, cell, highlightChanges, isCoefChoosen, typeCoef } = props;
        const newCoef = typeCoef || '';
        const [prevCoef, setCoef] = React.useState(newCoef);
        const [light, setLight] = React.useState(LIGHT.NONE);
        let timeoutID;
        const turnOffLight = () => {
            timeoutID = setTimeout(() => { setLight(LIGHT.NONE); }, 2500);
        };
        React.useEffect(() => {
            if (highlightChanges && prevCoef !== newCoef) {
                setLight(newCoef > prevCoef ? LIGHT.GREEN : LIGHT.RED);
                turnOffLight();
            }
            setCoef(newCoef);
            return () => { timeoutID && clearTimeout(timeoutID); };
        }, [coef.cf, highlightChanges]);
        const isChoosen = isCoefChoosen(cell.bet, coef.oddKey);
        const isDisabled = disabled || coef.bl === LOCK_STATE.BLOCKED;
        const cf = newCoef;
        const cfID = coef.oddKey;
        return <CoefTD {...props} {...{ light, isDisabled, isChoosen, cf, cfID, cell }}/>;
    };
    return highlightedCoefChanges;
};
const CoefTdComponent = (props) => {
    const onClick = useCallback(() => {
        props.cfID && props.onClick(props.cfID);
    }, [props.cfID]);
    return <td className={`${props.cell.st} ${props.cell.additionalClassName || ''} ${props.light}`} rowSpan={props.cell.rs} colSpan={props.cell.cs} style={props.style}>
      {props.isDisabled ?
            <span className='g-b-b'> {props.cf} </span>
            :
                <a className={`g-b ${props.isChoosen ? 'g-b-s' : ''}`} onClick={onClick}>
            {props.cf}
         </a>}
   </td>;
};
const CoefTd = React.memo(CoefTdComponent);
const HightlightCoefTd = highlightCoefChanges(CoefTd);
const TdComponent = (props) => <td className={`${props.cell.st} ${props.cell.additionalClassName || ''}`} rowSpan={props.cell.rs} colSpan={props.cell.cs} style={props.style}>
   {props.cell.txt}
</td>;
const Td = React.memo(TdComponent);
export { HightlightCoefTd, Td };



// WEBPACK FOOTER //
// ./src/web-frontend-components/line/outcomes/additional/tables/Td.jsx